export const MOTIVATION_ASSESSMENT = 'Assessment';
export const MOTIVATION_CONSTRAINT = 'Constraint';
export const MOTIVATION_DRIVER = 'Driver';
export const MOTIVATION_GOAL = 'Goal';
export const MOTIVATION_MEANING = 'Meaning';
export const MOTIVATION_OUTCOME = 'Outcome';
export const MOTIVATION_PRINCIPLE = 'Principle';
export const MOTIVATION_REQUIREMENT = 'Requirement';
export const MOTIVATION_STAKEHOLDER = 'Stakeholder';
export const MOTIVATION_VALUE = 'Value';

export const STRATEGY_CAPABILITY = 'Capability';
export const STRATEGY_VALUE_STREAM = 'ValueStream';
export const STRATEGY_COURSE_OF_ACTION = 'CourseOfAction';
export const STRATEGY_RESOURCE = 'Resource';

export const BUSINESS_ACTOR = 'BusinessActor';
export const BUSINESS_COLLABORATION = 'BusinessCollaboration';
export const BUSINESS_EVENT = 'BusinessEvent';
export const BUSINESS_FUNCTION = 'BusinessFunction';
export const BUSINESS_INTERACTION = 'BusinessInteraction';
export const BUSINESS_INTERFACE = 'BusinessInterface';
export const BUSINESS_OBJECT = 'BusinessObject';
export const BUSINESS_PROCESS = 'BusinessProcess';
export const BUSINESS_ROLE = 'BusinessRole';
export const BUSINESS_SERVICE = 'BusinessService';
export const BUSINESS_CONTRACT = 'Contract';
export const BUSINESS_PRODUCT = 'Product';
export const BUSINESS_REPRESENTATION = 'Representation';

export const APPLICATION_COLLABORATION = 'ApplicationCollaboration';
export const APPLICATION_COMPONENT = 'ApplicationComponent';
export const APPLICATION_EVENT = 'ApplicationEvent';
export const APPLICATION_FUNCTION = 'ApplicationFunction';
export const APPLICATION_INTERACTION = 'ApplicationInteraction';
export const APPLICATION_INTERFACE = 'ApplicationInterface';
export const APPLICATION_PROCESS = 'ApplicationProcess';
export const APPLICATION_SERVICE = 'ApplicationService';
export const APPLICATION_DATA_OBJECT = 'DataObject';

export const TECHNOLOGY_ARTIFACT = 'Artifact';
export const TECHNOLOGY_COMMUNICATION_NETWORK = 'CommunicationNetwork';
export const TECHNOLOGY_DEVICE = 'Device';
export const TECHNOLOGY_NODE = 'Node';
export const TECHNOLOGY_PATH = 'Path';
export const TECHNOLOGY_SYSTEM_SOFTWARE = 'SystemSoftware';
export const TECHNOLOGY_COLLABORATION = 'TechnologyCollaboration';
export const TECHNOLOGY_EVENT = 'TechnologyEvent';
export const TECHNOLOGY_FUNCTION = 'TechnologyFunction';
export const TECHNOLOGY_INTERACTION = 'TechnologyInteraction';
export const TECHNOLOGY_INTERFACE = 'TechnologyInterface';
export const TECHNOLOGY_PROCESS = 'TechnologyProcess';
export const TECHNOLOGY_SERVICE = 'TechnologyService';

export const PHYSICAL_DISTRIBUTION_NETWORK = 'DistributionNetwork';
export const PHYSICAL_EQUIPMENT = 'Equipment';
export const PHYSICAL_FACILITY = 'Facility';
export const PHYSICAL_MATERIAL = 'Material';

export const IMP_MIG_DELIVERABLE = 'Deliverable';
export const IMP_MIG_IMPLEMENTATION_EVENT = 'ImplementationEvent';
export const IMP_MIG_WORK_PACKAGE = 'WorkPackage';
export const IMP_MIG_GAP = 'Gap';
export const IMP_MIG_PLATEAU = 'Plateau';

export const OTHER_LOCATION = 'Location';
export const OTHER_GROUPING = 'Grouping';
export const OTHER_JUNCTION = 'Junction';
export const OTHER_AND_JUNCTION = 'AndJunction';
export const OTHER_OR_JUNCTION = 'OrJunction';

export const RELATIONSHIP_COMPOSITION = 'Composition';
export const RELATIONSHIP_AGGREGATION = 'Aggregation';
export const RELATIONSHIP_ASSIGNMENT = 'Assignment';
export const RELATIONSHIP_REALIZATION = 'Realization';
export const RELATIONSHIP_ASSOCIATION = 'Association';
export const RELATIONSHIP_INFLUENCE = 'Influence';
export const RELATIONSHIP_ACCESS = 'Access';
export const RELATIONSHIP_SERVING = 'Serving';
export const RELATIONSHIP_TRIGGERING = 'Triggering';
export const RELATIONSHIP_FLOW = 'Flow';
export const RELATIONSHIP_SPECIALIZATION = 'Specialization';
export const RELATIONSHIP_JUNCTION_AND = 'And Junction';
export const RELATIONSHIP_JUNCTION_OR = 'Or Junction';

export const RELATIONSHIP_TYPE_STRUCTURAL = 'Structural';
export const RELATIONSHIP_TYPE_DEPENDENCY = 'Dependency';
export const RELATIONSHIP_TYPE_DYNAMIC = 'Dynamic';
export const RELATIONSHIP_TYPE_OTHER = 'Other';
export const RELATIONSHIP_TYPE_CONNECTOR = 'Connector';

export const RELATIONSHIP_ACCESS_WRITE = 'Write';
export const RELATIONSHIP_ACCESS_READ = 'Read';
export const RELATIONSHIP_ACCESS_READWRITE = 'ReadWrite';
export const RELATIONSHIP_ACCESS_NONE = 'None';

export const LAYER_MOTIVATION = 'Motivation';
export const LAYER_STRATEGY = 'Strategy';
export const LAYER_BUSINESS = 'Business';
export const LAYER_APPLICATION = 'Application';
export const LAYER_TECHNOLOGY = 'Technology';
export const LAYER_PHYSICAL = 'Physical';
export const LAYER_IMP_MIG = 'Implementation & Migration';
export const LAYER_OTHER = 'Other';

export const ASPECT_PASSIVE = 'Passive structure';
export const ASPECT_BEHAVIOR = 'Behavior';
export const ASPECT_ACTIVE = 'Active structure';
export const ASPECT_MOTIVATION = 'Motivation';

export const ARCHIMATE_MODEL = 'archimate:Model';
export const ARCHIMATE_IDOBJECT = 'archimate:IdObject';
export const ARCHIMATE_ELEMENT = 'archimate:BaseElement';
export const ARCHIMATE_ELEMENTS = 'archimate:Elements';
export const ARCHIMATE_RELATIONSHIP = 'archimate:Relationship';
export const ARCHIMATE_RELATIONSHIPS = 'archimate:Relationships';
export const ARCHIMATE_VIEW = 'archimate:View';
export const ARCHIMATE_VIEW_ELEMENT = 'archimate:ViewElement';
export const ARCHIMATE_NODE = 'archimate:Node';
export const ARCHIMATE_CONNECTION = 'archimate:Connection';
export const ARCHIMATE_WAYPOINT = 'archimate:Waypoint';
export const ARCHIMATE_WAYPOINTS = 'archimate:Waypoints';
export const ARCHIMATE_LABEL = 'archimate:Label'; // => only use once
export const ARCHIMATE_STYLE = 'archimate:Style';
export const ARCHIMATE_FILLCOLOR = 'archimate:FillColor';
export const ARCHIMATE_LINECOLOR = 'archimate:LineColor';
export const ARCHIMATE_FONT = 'archimate:Font';
export const ARCHIMATE_GROUP = 'archimate:Group';
export const ARCHIMATE_IMAGE = 'archimate:Image';
